var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',{attrs:{"card":""}},_vm._l((_vm.dataGroups),function(group){return _c('b-tab',{key:group.name,attrs:{"title":group.name}},[_c('import-specific-data',{attrs:{"name":group.name,"save-func":group.saveFunc,"html-warning-from-data-func":group.htmlWarningFromDataFunc}})],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-119811f1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/dataAdmin/views/ImportDataView.vue
// module id = null
// module chunks = 